import { Bell } from "lucide-react";
import { useEffect, useState } from "react";
import {
  useLayout,
  playNotificationSound,
} from "../../../../contexts/UseLayout";

export function ButtonNotificacoes() {
  const { notifications } = useLayout();
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const hasUnreadNotifications =
    Array.isArray(notifications) &&
    notifications.some((notification: any) => !notification?.read);

  useEffect(() => {
    if (hasUnreadNotifications) {
      setIsAnimating(true);
      playNotificationSound();
      setTimeout(() => {
        setIsAnimating(false);
      }, 1000);
    }
  }, [notifications]);

  return (
    <>
      <div
        className={`relative animate__animated ${isAnimating ? "animate__tada" : ""}`}
      >
        <Bell size={20} />
        {hasUnreadNotifications && (
          <div className="bg-red-500 text-white text-[8px] rounded-full h-4 w-4 flex items-center justify-center absolute -top-2 -right-2">
            {Array.isArray(notifications)
              ? notifications.filter((notification: any) => !notification?.read)
                  .length
              : 0}
          </div>
        )}
      </div>
    </>
  );
}
